import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import CommercialView from "@/pages/CommercialView";
import DealDetail from "@/pages/DealDetail";
import ManagerDashboard from "@/pages/ManagerDashboard";
import AdminSettings from "@/pages/AdminSettings";
import Layout from "@/components/Layout";
import "@/App.css";

function ProtectedLayout({ roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-gray-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-gray-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/app/admin" replace />;
  if (user.role === "manager") return <Navigate to="/app/manager" replace />;
  return <Navigate to="/app" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="bottom-right" closeButton richColors={false} />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/app" element={<CommercialView />} />
            <Route path="/app/deals/:id" element={<DealDetail />} />
          </Route>
          <Route element={<ProtectedLayout roles={["manager", "admin"]} />}>
            <Route path="/app/manager" element={<ManagerDashboard />} />
          </Route>
          <Route element={<ProtectedLayout roles={["admin"]} />}>
            <Route path="/app/admin" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
